import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import toast from 'react-hot-toast';
import { useAuth } from '../context/AuthContext';
import ThemeSwitcher from '../components/ThemeSwitcher';

export default function Login() {
  const { login }             = useAuth();
  const navigate              = useNavigate();
  const [form, setForm]       = useState({ username: '', password: '' });
  const [loading, setLoading] = useState(false);
  const [showPwd, setShowPwd] = useState(false);

  const handleSubmit = async e => {
    e.preventDefault();
    if (!form.username || !form.password) { toast.error('Enter username and password'); return; }
    setLoading(true);
    try {
      const user = await login(form.username.trim(), form.password);
      toast.success(`Welcome, ${user.username}!`);
      navigate(user.role === 'admin' ? '/admin' : '/dashboard', { replace: true });
    } catch (err) {
      toast.error(err.response?.data?.message || 'Login failed');
    } finally { setLoading(false); }
  };
return (
  <div className="login-page">
    <div className="login-card">
      <div className="login-logo">🪪</div>
      <h1 className="login-title">ID<strong>Portal</strong></h1>
      <p className="login-sub">Sign in to your account</p>

      <form onSubmit={handleSubmit} className="login-form">

        {/* USERNAME */}
        <div className="form-group">
          <label>Username</label>
          <input
            className="form-input"
            autoFocus
            placeholder="Enter username"
            style={{ width: '100%', boxSizing: 'border-box' }}
            value={form.username}
            onChange={e => setForm({ ...form, username: e.target.value })}
          />
        </div>

        {/* PASSWORD */}
        <div className="form-group">
          <label>Password</label>
          <div style={{ position: 'relative', width: '100%' }}>
            <input
              className="form-input"
              type={showPwd ? 'text' : 'password'}
              placeholder="Enter password"
              style={{ width: '100%', paddingRight: 40, boxSizing: 'border-box' }}
              value={form.password}
              onChange={e => setForm({ ...form, password: e.target.value })}
            />
            <button
              type="button"
              onClick={() => setShowPwd(s => !s)}
              style={{
                position: 'absolute', right: 10, top: '50%',
                transform: 'translateY(-50%)', background: 'none',
                border: 'none', cursor: 'pointer', fontSize: '1rem',
                color: 'var(--text-muted)', padding: '0 2px'
              }}
            >
              {showPwd ? '🙈' : '👁️'}
            </button>
          </div>
        </div>

        {/* SUBMIT */}
        <button
          className="btn btn-primary"
          style={{ width: '100%', justifyContent: 'center', padding: 12, fontSize: '.92rem', boxSizing: 'border-box' }}
          disabled={loading}
        >
          {loading ? '⏳ Signing in…' : '🔐 Sign In'}
        </button>

      </form>

      <div className="login-theme">
        <span className="login-theme-label">Theme:</span>
        <ThemeSwitcher size="sm" />
      </div>
    </div>
  </div>
);}